import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ActionReferenceData } from '../actions.model';
import { ActionReferenceApi } from './action-reference-api.token';

@Injectable({ providedIn: 'root' })
export class UnresolvedActionReferenceService implements ActionReferenceApi {
  loadReferenceData(): Observable<ActionReferenceData> {
    return of({
      actionTypes: [],
      statuses: [],
      priorities: [],
      communicationPreferences: [],
      dependencyMessage: 'Action system-code catalogs are not available yet.',
    });
  }
}
